<template>
  <section class="scenarios">
    <div class="container">
      <div class="title-area reveal">
        <h2 class="section-title">See Bizzento in Action</h2>
        <p class="section-subtitle">
          From instant execution to long-term strategy.
        </p>
      </div>

      <div class="scenarios-grid">
        <div class="scenario-card ready-card reveal">
          <div class="card-content">
            <div class="text-side">
              <h3><span class="card-num">01.</span> Daily Operations</h3>
              <p>
                Watch Bizzento bridge the gap between a customer inquiry and a
                confirmed booking without you lifting a finger.
              </p>
            </div>
            <div class="visual-side">
              <div class="gif-window">
                <div class="window-controls">
                  <span></span><span></span><span></span>
                </div>
                <img
                  src="../assets/images/pabu-daily-operations.gif"
                  alt="Daily Operations"
                  class="scenario-gif"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="secondary-row">
          <div class="scenario-card reveal delay-1">
            <div class="card-content">
              <h3><span class="card-num">02.</span> Business Intelligence</h3>
              <p>
                Transform raw data into visual growth charts and actionable
                insights.
              </p>
              <div class="gif-window mini">
                <img
                  src="../assets/images/pabu-business-intelligence.gif"
                  alt="Intelligence"
                  class="scenario-gif"
                />
              </div>
            </div>
          </div>

          <div class="scenario-card reveal delay-2">
            <div class="card-content">
              <h3><span class="card-num">03.</span> Strategic Guidance</h3>
              <p>
                Market analysis and revenue projections to guide your next big
                move.
              </p>
              <div class="gif-window mini">
                <img
                  src="../assets/images/pabu-strategic-guidance.gif"
                  alt="Strategic"
                  class="scenario-gif"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.scenarios {
  --bg-warm-base: #f2eee0;
  --sunlight-glow: #faefca;
  --soft-gold: #f8e39f;
  --dark-accent: #1a1a1a;
  --text-muted: #8e8a82;

  padding: 100px 24px;
  background: var(--bg-warm-base);
  color: var(--dark-accent);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.title-area {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: clamp(2rem, 4vw, 2.5rem);
  font-weight: 800;
  margin-bottom: 12px;
}

.scenarios-grid {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.scenario-card {
  background: white;
  border-radius: 32px;
  padding: 48px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
}


h3 {
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-num {
  color: var(--soft-gold);
  font-weight: 800;
  font-size: 1.2rem;
}

.text-side p {
  color: var(--text-muted);
  font-size: 1.1rem;
  line-height: 1.6;
  max-width: 500px;
}

/* Main Layouts */
.ready-card .card-content {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 60px;
  align-items: center;
}

.secondary-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

/* Mockup Windows */
.gif-window {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid #eee;
}

.window-controls {
  background: #f8f8f8;
  padding: 12px;
  display: flex;
  gap: 8px;
}

.window-controls span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #e0e0e0;
}

.scenario-gif {
  width: 100%;
  display: block;
}

.mini {
  margin-top: 32px;
}

/* Mobile Responsiveness */
@media (max-width: 992px) {
  .ready-card .card-content,
  .secondary-row {
    grid-template-columns: 1fr;
  }
  .scenario-card {
    padding: 32px;
  }
}
</style>
